
export class SelectOption {
  label: string | number;
  value: string | number;
  icon?: string;
}

export const enumToOptions = (type: any, exceptions?: any[]): SelectOption[] => {
  let options = Object.values(type).map(el => ({
    label: el,
    value: el,
  } as SelectOption));
  if (exceptions) {
    options = options.filter(option => !exceptions.includes(option.label));
  }
  return options;
};

export const enumValuesToOptions = (enums: any[]): SelectOption[] => {
  return enums.map(el => ({
    label: el,
    value: el,
  } as SelectOption));
};
